import {atom} from "@reatom/core"
import {getModelAtom, getModel} from "../model"
import {useAtom} from "@reatom/npm-react"
import {useEffect, useState} from "react"


function default_validate_value(value) {
  return !(
    value === null
    || value === undefined
    || value === ''
  )
}

// const validateTab = tab_model.validate_callback ? tab_model.validate_callback : () => {
const default_validate_tab = (ctx, schema) => {
  // console.log('validateTab schema', schema)
  let is_valid = true
  // console.log('default_validate_tab', is_valid)
  for (const [model_key, options] of Object.entries(schema)) {
    const model = getModel(model_key)
    const model_atom = model.atom
    const value = ctx.get(model_atom)

    if (options?.conditional_atom) {
      const is_active = ctx.get(options.conditional_atom)
      // console.log(is_active)
      if (!is_active) {
        continue
      }
    }
    // console.log('validateTab model', model)
    let is_value_valid
    // console.log(options)
    if (options?.validate) {
      // console.log('validate', options.validate)
      is_value_valid = options.validate(value)
    } else {
      is_value_valid = default_validate_value(value)
    }
    // console.log(model_key, value, is_value_valid, options, !is_value_valid && options.required === true)
    if (!is_value_valid && options.required === true) {
      is_valid = false
      // break
    }

    if (is_value_valid) {
      model.messages_atom(ctx, [])
    }
  }
  return is_valid
}


/**
 * Installs validation and conditional appearance of fields
 *
 * Example of schema param
 * {
 * 'model_name.model_prop': {
 *       appearsOn: {
 *           models: ['tournament.double_selection'], // preloads some models from global store to callback argument
 *                                                    // with the dot replaced by an underscode in its name
 *           callback: (computed) => { // a callback fired inside the "atom(() => {...})" computed atom
 *                                     // that returns return value of callback
 *                                     // look: getConditionalModelAtom
 *               return computed.tournament_double_selection == true
 *           }
 *       },
 *       validate: (value) => Number(value) > 0 // a validation callback
 *       validation_message: 'Something went wrong' // a validation message
 *   },
 *  }
 *
 * if a field is not required, but must invoke the tab validation:
 * {
 *  'model_name.model_prop': {
 *      required: false
 *  }
 * }
 *
 * @param {*} ctx
 * @param {*} tab_model_key key of the tab in the global store
 * @param {*} schema look: description
 * @returns
 */
export function installTabValidation(ctx, tab_model_key, schema) {

  const unsubscribes = []
  const conditional_atoms = {}

  const tab_model = getModel(tab_model_key)
  const tab_atom = tab_model.atom
  const tab_schema = tab_model.schema
  // const tab_atom = getModelAtom(tab_model_key)

  for (const [model_key, options] of Object.entries(schema)) {
    const _options = Object.assign({
      required: true,
    }, options)
    schema[model_key] = _options
  }

  const validateTab = tab_model.schema.validation_callback
    ? tab_model.schema.validation_callback
    : default_validate_tab

  // console.log(
  //     'validation_invoke_atom',
  //     tab_model,
  //     tab_model.schema.validation_invoke_atom,
  //     tab_model.schema.validation_callback,
  //     validateTab
  // )

  const hooked_atoms = []

  if (tab_model.schema.validation_invoke_atom) {
    hooked_atoms.push(tab_model.schema.validation_invoke_atom)
    // const unsubscribe = ctx.subscribe(
    //     tab_model.schema.validation_invoke_atom,
    //     () => {
    //         const is_valid = validateTab(ctx, schema)
    //         const tab_state = ctx.get(tab_atom)
    //         if(tab_state.is_done != is_valid){
    //             tab_atom(ctx, {...tab_state, is_done: is_valid})
    //         }
    //     }
    // )
    // unsubscribes.push(unsubscribe)
  }


  for (const [model_key, options] of Object.entries(schema)) {

    if (options?.appearsOn) {
      const conditional_atom = getConditionalModelAtom(
        options.appearsOn.models,
        options.appearsOn.callback,
      )
      options.conditional_atom = conditional_atom
      conditional_atoms[model_key] = conditional_atom
      // console.log('conditional_atoms', conditional_atoms)
    }

    const hooked_model = getModel(model_key)
    const hooked_model_atom = hooked_model.atom
    // hooked_model.schema.validation = options
    hooked_model.validation = options
    // hooked_model.messages_atom = atom([])

    hooked_atoms.push(hooked_model_atom)
  }

  for (const hooked_atom of hooked_atoms) {
    const unsubscribe = ctx.subscribe(hooked_atom, () => {
      const is_valid = validateTab(ctx, schema)
      const tab_state = ctx.get(tab_atom)
      if (tab_state.is_done != is_valid) {
        tab_atom(ctx, {...tab_state, is_done: is_valid})
      }
    })
    unsubscribes.push(unsubscribe)
  }

  tab_schema.validation_atoms = conditional_atoms

  return [conditional_atoms, unsubscribes, validateTab]
}

/**
 * Builds a computed atom.
 * Installs spying of only nesssesory models passed in appearsOn.models list
 *
 * @param {*} source_models
 * @param {*} callback
 * @returns
 */
export function getConditionalModelAtom(source_models, callback) {
  const schema = {}
  const computed = {}
  for (const model_key of source_models) {
    const key = model_key.replace('.', '_')
    schema[key] = model_key
    computed[key] = null
  }
  const computed_atom = atom((ctx) => {
    for (const [key, model_key] of Object.entries(schema)) {
      computed[key] = ctx.spy(getModelAtom(model_key))
    }
    return callback(computed)
  })
  return computed_atom
}

export function useConditionalModelAtom(source_models, callback) {
  const computed_atom = getConditionalModelAtom(source_models, callback)
  return useAtom(computed_atom)
}


export function checkTabValidation(ctx, tab_model) {
  // for(){

  // }
  // console.log(tab_model)

  // for(const [model_key, options] of Object.entries(tab_model.schema.validation_schema)){
  //     const model_atom = getModelAtom(model_key)
  //     const value = ctx.get(model_atom)
  //     value = ctx.get(tab_model.schema.validation_atoms[model_key])
  // }

  const schema = tab_model.schema.validation_schema

  for (const [model_key, options] of Object.entries(schema)) {
    const model = getModel(model_key)
    const model_atom = model.atom
    const value = ctx.get(model_atom)
    if (options?.conditional_atom) {
      const is_active = ctx.get(options.conditional_atom)
      if (!is_active) {
        continue
      }
    }
    let is_value_valid
    if (options?.validate) {
      is_value_valid = options.validate(value)
    } else {
      is_value_valid = default_validate_value(value)
    }
    // console.log(model_key, value, is_value_valid, !is_value_valid && options.required === true)
    if (!is_value_valid && options.required === true) {
      model.messages_atom(ctx, [{
        text: options.validation_message ?? 'Поле не заполнено или заполнено неверно'
      }])
    } else {
      // model.messages_atom(ctx, [{
      //     message: 'Верно'
      // }])
      model.messages_atom(ctx, [])
    }
  }

  // for(const [model_key, options] of Object.entries(schema)){
  //         const model_atom = getModelAtom(model_key)
  //         const value = ctx.get(model_atom)

  //         if(options?.conditional_atom){
  //             const is_active = ctx.get(options.conditional_atom)
  //             // console.log(is_active)
  //             if(!is_active){
  //                 continue
  //             }
  //         }
  //         let is_value_valid
  //         // console.log(options)
  //         if(options?.validate){
  //             // console.log('validate', options.validate)
  //             is_value_valid = options.validate(value)
  //         }else{
  //             is_value_valid = !!value
  //         }
  //         // console.log(model_key, value, is_value_valid, options, !is_value_valid && options.required === true)
  //         if(!is_value_valid && options.required === true){
  //             is_valid = false
  //             break
  //         }
  //     }
}


export function usePreventValidation() {
  const [prevent_validation, set_prevent_validation] = useState(true)
  useEffect(() => {
    setTimeout(() => {
      set_prevent_validation(false)
    }, 1000)
  }, [])
  return {prevent_validation, set_prevent_validation}
}

export function shuffleArray(array) {
  const a = array.slice()
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[a[i], a[j]] = [a[j], a[i]]
  }
  return a
}